const similarStylesSelectors = {
  trigger: '[data-similar-styles-trigger]',
  sizeGuideWrapper: '[data-size-guide-wrapper]',
};

let nextSimilarStylesInstanceId = 0;

// The trigger and the "Need some help with sizing?" line share the same slot —
// only one shows at a time.
function updateSimilarStylesTriggerVisibility(variant) {
  setSimilarStylesTriggerVisible(Boolean(variant && variant.available === false));
}

function setSimilarStylesTriggerVisible(showTrigger) {
  document.querySelectorAll(similarStylesSelectors.trigger).forEach((trigger) => {
    setHiddenWithFade(trigger, !showTrigger);
  });
  document.querySelectorAll(similarStylesSelectors.sizeGuideWrapper).forEach((wrapper) => {
    setHiddenWithFade(wrapper, showTrigger);
  });
}

function waitForTagalys(callback) {
  if (window.Tagalys && window.tagalysReady) {
    callback();
    return;
  }
  document.addEventListener('tagalys:ready', callback, { once: true });
}

// Data source: the dedicated "Similar Styles Widget ID" theme setting
// (window.theme.tagalys.similarStylesWidget, theme.liquid). While that's blank
// it falls back to the "Similar Products" widget that powers PDP "You may also
// like" — a generic cross-sell widget, not scoped to "same style, in-stock
// only". Kept as its own setting so swapping in Tagalys' dedicated widget
// doesn't also change the PDP carousel.
function loadSimilarStyles(productId) {
  const drawer = document.querySelector('product-set-drawer');
  const widgetId = window.theme?.tagalys?.similarStylesWidget?.id || window.theme?.tagalys?.similarProductsWidget?.id;
  if (!drawer || !widgetId || !productId) return;

  const containerId = `similar-styles-widget-${++nextSimilarStylesInstanceId}`;
  drawer.renderContent(`<div id="${containerId}"></div>`);

  waitForTagalys(() => {
    const recommendations = window.Tagalys?.UIWidgets?.Recommendations;
    if (!recommendations || typeof recommendations.init !== 'function') return;

    recommendations.init(`#${containerId}`, {
      recommendationId: widgetId,
      productId,
      // Shared with the PDP "You may also like" widget (theme.js /
      // similar-styles-widget.js) — same renderProductCard() output, so this
      // gets the exact same quick-add-inline hover/size/add-to-cart behaviour.
      templates: window.theme.similarStylesTemplates(),
    });
  });
}

function openSimilarStylesDrawer(triggeredBy) {
  const drawer = document.querySelector('product-set-drawer');
  if (!drawer) return;

  drawer.openWithTitle(drawer.dataset.similarStylesTitle, triggeredBy);
  loadSimilarStyles(drawer.dataset.productId);
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(similarStylesSelectors.trigger).forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      openSimilarStylesDrawer(trigger);
    });
  });

  // Instant update on size click (product-info.js previewVariantAvailability) —
  // the variantChange handler below then confirms it once the re-render lands.
  subscribe(PUB_SUB_EVENTS.variantAvailabilityPreview, ({ data: { available } }) => {
    setSimilarStylesTriggerVisible(!available);
  });

  subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { variant } }) => {
    updateSimilarStylesTriggerVisibility(variant);
  });

  // The button defaults to hidden server-side (matches the normal "nothing
  // selected yet" state) — sync it here too for the deep-link case
  // (?variant=<sold-out-id>), which skips the variantChange event entirely.
  const initialVariantScript = document.querySelector('variant-selects [data-selected-variant]');
  if (initialVariantScript?.innerHTML.trim()) {
    try {
      updateSimilarStylesTriggerVisibility(JSON.parse(initialVariantScript.innerHTML));
    } catch (error) {
      window.console.error('TWP | similarStyles | failed to parse initial selected variant', error);
    }
  }
});
